import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import { useAppSelector, useAppDispatch } from 'app/config/store';
import { Form, Input, Button, Select, Breadcrumb, Row, Switch, Tag } from 'antd';
import { Link, RouteComponentProps } from 'react-router-dom';
import { getEcole } from '../ecole/ecole.reducer';
import { getClasses } from '../classe/classe.reducer';
import { createNotification } from './notification.reducer';

const NotificationNew = (props: RouteComponentProps<{ id: string; ecoleid: string; anneeScolaireId: string }>) => {
  const classes = useAppSelector(state => state.classe.entities);
  const [message, setMessage] = useState('');
  const [recipientMode, setRecipientMode] = useState(0); // 0: tous, 1: classes, 2: unique
  const [matricule, setMatricule] = useState('');
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const notification = useAppSelector(state => state.notification.entity);
  const updateSuccess = useAppSelector(state => state.notification.updateSuccess);
  const dispatch = useAppDispatch();

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/notification/${currentEcole && currentEcole.id}/${props.match.params.anneeScolaireId}`);
  };

  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getClasses(props.match.params.ecoleid));
  }, []);

  const handleMessageChange = e => setMessage(e.target.value);

  const handleRecipientChange = value => {
    setRecipientMode(value);
  };

  const saveMessage = values => {
    const entity = {
      ...notification,
      ...values,
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
      message,
      matricule: recipientMode === 2 ? matricule : null,
      modeEnvoi: recipientMode,
    };

    dispatch(createNotification(entity));
    handleClose(event);
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 10 },
  };

  const { match } = props;

  return (
    <div>
      <Breadcrumb className="p-4">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/notification/${currentEcole && currentEcole.id}/${props.match.params.anneeScolaireId}`}>Messages</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={match.url}>Nouveau</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Row className="justify-content-center mb-3">
        <h3>Nouveau Message</h3>
      </Row>
      <Form {...layout} onFinish={saveMessage} initialValues={notification}>
        <Form.Item name="message" label="Message" required>
          <Input.TextArea placeholder="contenu du message" rows={5} onChange={handleMessageChange} />
          {message.length < 8 && (
            <p>
              <span style={{ color: '#F28E19' }}>*</span>
              Le message doit contenir au moins 8 caractères.
              <span style={{ color: '#F28E19', fontWeight: 'bold' }}>(restant: {8 - message.length})</span>
            </p>
          )}
        </Form.Item>

        <Form.Item label="Destinataires">
          <Select value={recipientMode} onChange={handleRecipientChange} style={{ width: '100%' }}>
            <Select.Option value={0}>Tous les parents d&apos;élèves</Select.Option>
            <Select.Option value={1}>Les parents d&apos;une ou plusieurs classes</Select.Option>
            <Select.Option value={2}>Un parent d&apos;élève (matricule)</Select.Option>
          </Select>
        </Form.Item>

        {recipientMode === 1 && (
          <>
            <Form.Item name="classes" label="Classe(s)">
              <Select mode="multiple" placeholder="Classes" optionFilterProp="children" allowClear style={{ width: '100%' }}>
                {classes.map(classe => (
                  <Select.Option key={classe.id} value={classe.id}>
                    {classe.nom}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="etatPaiement" label="Etat Paiement">
              <Select placeholder="Etat" optionFilterProp="children" allowClear>
                <Select.Option value="A_JOUR">
                  <Tag color="green">A JOUR</Tag>
                </Select.Option>
                <Select.Option value="NON_A_JOUR">
                  <Tag color="red">NON A JOUR</Tag>
                </Select.Option>
              </Select>
            </Form.Item>

            <Form.Item name="statutPresence" label="Statut">
              <Select placeholder="Etat" optionFilterProp="children" allowClear>
                <Select.Option value="ABSENT">
                  <Tag color="red">ABSENT</Tag>
                </Select.Option>
                <Select.Option value="PRESENT">
                  <Tag color="green">PRESENT</Tag>
                </Select.Option>
              </Select>
            </Form.Item>
          </>
        )}

        {recipientMode === 2 && (
          <Form.Item label="Matricule élève" required>
            <Input placeholder="Entrez le matricule de l'élève" value={matricule} onChange={e => setMatricule(e.target.value)} />
          </Form.Item>
        )}

        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 6 }}>
          <Button
            style={{ backgroundColor: '#F28E19', color: 'white' }}
            htmlType="submit"
            disabled={!message || message.length < 8 || (recipientMode === 2 && !matricule)}
          >
            Envoyer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default NotificationNew;
